export const areasOfWork = [
  { area: 'Renewable Energy' },
  { area: 'Green Technology' },
  { area: 'Upskilling Opportunities' },
  { area: 'Environmental Issues' },
  { area: 'Career Development' },
  { area: 'Sustainability' },
];
